import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AccessResult, TicketResult } from 'projects/flow-gui-access/components/core'
// eslint-disable-next-line
import http from 'API/http'
import { ContentHeader, StaticBox } from 'components/basic'
import axios from 'axios'

const CancelToken = axios.CancelToken
class Search extends Component {
  constructor (props) {
    super(props)
    this.state = {
      limit: 10,
      activePage: 0,
      query: props.search.query || '',
      searchName: '',
      menu: false,
      index: props.search.index || true,
      icon: 'fa-home',
      lastResult: 10,
      loading: false
    }
    this.timer = null
    this.cancelToken = CancelToken.source()
  }
  componentWillUnmount () {
    this.clearSearch()
  }
  componentDidMount () {
    this.setState({
      index: this.props.search.index !== false,
      icon: (this.props.search.index === false) ? 'fa-commenting-o' : 'fa-home'
    })
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: 'Search'
    })
  }
  loadMore () {
    if (this.state.lastResult < this.state.limit) return
    this.setState({activePage: ++this.state.activePage, loading: true}, e => {
      this.dispatchQuery(this.props.search.query, this.state.index, true)
    })
  }
  async dispatchQuery (query, access, append) {
    this.cancelToken.cancel()
    let cancelToken = CancelToken.source()
    this.cancelToken = cancelToken
    var endpoint = (access ? '2.3/accesses/search/' : '2.3/tickets/search/')
    var [err, res] = await http.get(endpoint + query, {limit: this.state.limit, offset: (this.state.limit * this.state.activePage)}, null, { cancelToken: cancelToken.token })
    if (err) return this.setState({loading: false})
    this.setState({lastResult: res.data.length, loading: false})
    if (append) res.data = [...this.props.search.results, ...res.data]
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: query,
        results: res.data,
        index: access
      }
    })
  }
  handleChange (event, access) {
    this.clearSearch()
    var query = event.target.value
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.setState({lastResult: 10, activePage: 0}, e => this.dispatchQuery(query, access))
    }, 350)
  }
  clearSearch () {
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: '',
        results: false,
        index: this.state.index
      }
    })
  }
  setIndex (index, icon) {
    this.setState({menu: false, index: index, icon: icon})
    this.clearSearch()
  }
  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Access' subtitle='Search' icon='fa-search'/>
        <hr />
        <div className='row'>
          <StaticBox cols={12} xs={12} sm={12} icon='search' title='Search'>
            <div className='input-group search big-search col-md-12'>
              <span className='input-group-addon' onClick={(e) => { this.setState({menu: !this.state.menu}) }}>
                <i className={'fa fa-fw ' + this.state.icon} />
                <div className={'search-index-menu ' + (this.state.menu ? '' : 'hidden')}>
                  <a onClick={() => { this.setIndex(true, 'fa-home') }}><i className='fa fa-fw fa-home' /></a>
                  <a onClick={() => { this.setIndex(false, 'fa-commenting-o') }}><i className='fa fa-fw fa-commenting-o' /></a>
                </div>
              </span>
              <input
                ref={el => (this.searchField = el)}
                type='text'
                defaultValue={this.props.search.query}
                onChange={(e) => {
                  this.handleChange(e, this.state.index)
                }}
                className='form-control input-lg'
                placeholder='Search for...' />
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <div className='list-group flow-search-results full-search-results'>
                  {this.props.search.results && this.props.search.results.map((result, i) => {
                    if (!result.ticketRef) {
                      return <AccessResult clearSearch={e => this.clearSearch()} key={i} result={result} active={(++i === this.state.location)} />
                    } else {
                      return <TicketResult clearSearch={e => this.clearSearch()} key={i} result={result} active={(++i === this.state.location)} />
                    }
                  })}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 text-center padding-20'>
                {this.props.search.results && !!this.props.search.results.length && !(this.state.lastResult < this.state.limit) && <button onClick={e => this.loadMore()} className='btn btn-primary'>{this.state.loading ? <i className='fa fa-spin fa-spinner' /> : 'Load more results'}</button>}
              </div>
            </div>
          </StaticBox>
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
Search = connect(state => state.siteReducer)(Search)
export default Search



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/search/search.js